// ucakTipleri.js — ORTAK UÇAK TİPİ LİSTESİ: OKUMA + ARAMA TEK KAYNAK (30 Eyl 2026)
//
// 🔑 Serkan: "Drop menü olması gerekir, elle giremez, var olandan seçer." · kaynak FAA JO
//    7360.1 (ICAO Doc 8643 belirteçleri), tablo `aircraft_types` (20260930c/d).
// Kullananlar: AIRCRAFTS tip seçici (AdminPanel) ve süper admin AIRCRAFT TYPES listesi —
// ikisi de BURADAN okur ve arar; kopya yazılmaz (tek tip + tek kaynak).
// 🔴 ÖNCESİ (ölçüldü): tip, koda gömülü 39 modellik bir katalogdan (AIRCRAFT_DB) ya da
//    serbest metinden geliyordu; katalogun 12 kodu ICAO'ya göre yanlıştı (F7X ≠ FA7X,
//    Legacy 500 = E50P = Phenom 100 …) — FPL tipi ile uyuşmaz, pilot tip kapısını bozardı.
import { supabase } from './supabaseClient';
import { ilkEksik } from './components/tasarim';
import { SAYILI, hepsiniOku, okumaHataMetni } from './components/kesikOkuma';
import { gerekceTamam, gerekceIpucuMetni } from './components/gerekceKurali';   // ortak gerekçe kuralı (21 Eki 2026, K7)

// Liste PARÇA PARÇA, ortak `hepsiniOku` ile okunur (21 Eki 2026, kod taraması W5). Kendi sayfa döngüsü vardı: sunucunun
// satır sınırı 1000'den düşükse ilk sayfada "son sayfa" sanıp durur, listeyi SESSİZCE keserdi (İlke 1). Ortak okuma gelen
// kadar ilerler ve toplamı (SAYILI) sayar; sayılar tutmazsa liste verilmez, "kesik" denir. Sıra (kod, üretici, model)
// korunur; parça sınırını `id` kesinleştirir. Sütun listesi TEK: iki ekranın (AIRCRAFTS seçici, süper admin AIRCRAFT
// TYPES) istediği her şey — çağıran ayrı liste yazmaz.
export async function ucakTipleriniOku() {
  const r = await hepsiniOku(() => supabase.from('aircraft_types').select('id,designator,manufacturer,model,aircraft_class,engine,icao_wtc,source,reason,added_by,created_at,withdrawn_at', SAYILI)
    .order('designator').order('manufacturer').order('model'));
  const hata = okumaHataMetni(r);
  return hata ? { tipler: [], hata } : { tipler: r.data, hata: null };
}

// Arama: kod başı ya da "ÜRETİCİ MODEL" içinde; boşluk/tire farkı sayılmaz ("G 450", "FALCON7X").
// `sinir + 1` satır döner: çağıran, sınırı aşan sonucu "daraltın" diye söyleyebilsin.
const aramaAnahtari = v => String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
export function tipAra(tipler, sorgu, sinir = 30) {
  const q = aramaAnahtari(sorgu);
  if (q.length < 2) return [];
  return (tipler || []).filter(t => aramaAnahtari(t.designator).startsWith(q)
    || aramaAnahtari(`${t.manufacturer} ${t.model}`).includes(q)).slice(0, sinir + 1);
}

// ── ADD TYPE (süper admin, adım 4c) ──────────────────────────────────────────
// 🔑 Serkan (30 Eyl): "Süper adminde tip girişi GO2'nun yapacağı bir iş … kaynak FAA veya
//    ICAO olacak." Kaynak değerleri veritabanı kısıtı + politika (20260930f) ile AYNI olmalı —
//    nöbetçi test ikisini karşılaştırır. FAA baskısı değişince yalnız burası değişir.
export const ELLE_KAYNAKLAR = ['ICAO Doc 8643', 'FAA JO 7360.1K'];
// Motor: sayı + tür harfi — FAA/ICAO'daki biçim ("2J"). Elle yazılmaz, iki listeden seçilir.
export const MOTOR_SAYILARI = ['1', '2', '3', '4'];
export const MOTOR_TURLERI = [['J', 'Jet'], ['T', 'Turboprop'], ['P', 'Piston'], ['E', 'Electric']];
export const WTC_SINIFLARI = ['Light', 'Medium', 'Heavy', 'Super'];
// Liste yalnız sabit kanat (Serkan, 30 Eyl: "ikinci satır") — elle ekleme de öyle.
export const ELLE_SINIF = 'Fixed-wing';
// ICAO'nun tip arama sayfası (30 Eyl 2026'da açılıp doğrulandı: "Aircraft Type Designators").
export const ICAO_TIP_ARAMA = 'https://www.icao.int/operational-safety/doc-8643-aircraft-type-designators/search';

/** Tip verisinin alanları (ekleme ve düzeltme ortak) — kapı ve zorunlu alan rengi AYNI liste (5 Eki 2026). Sıra = mesaj
 *  sırası. Motor iki seçimdir (sayı + tür), cümlesi tek. */
export function tipVeriAlanlari(f) {
  const motor = 'Choose the number and type of engines.';
  return [
    { alan: 'manufacturer', zorunlu: true, gecerli: !!String(f.manufacturer || '').trim(), mesaj: 'Manufacturer is required.' },
    { alan: 'model', zorunlu: true, gecerli: !!String(f.model || '').trim(), mesaj: 'Model is required.' },
    { alan: 'motorSayi', zorunlu: true, gecerli: MOTOR_SAYILARI.includes(f.motorSayi), mesaj: motor },
    { alan: 'motorTur', zorunlu: true, gecerli: MOTOR_TURLERI.some(([k]) => k === f.motorTur), mesaj: motor },
    { alan: 'icao_wtc', zorunlu: true, gecerli: WTC_SINIFLARI.includes(f.icao_wtc), mesaj: 'Choose the ICAO wake turbulence category.' },
    { alan: 'source', zorunlu: true, gecerli: ELLE_KAYNAKLAR.includes(f.source), mesaj: 'Choose the source the data was taken from.' },
    { alan: 'reason', zorunlu: true, gecerli: gerekceTamam(f.reason), mesaj: gerekceIpucuMetni(f.reason) },
  ];
}
/** Ekleme formunun alanları: önce ICAO kodu. */
export const tipAlanlari = (f) => [
  { alan: 'designator', zorunlu: true, gecerli: /^[A-Z0-9]{2,4}$/.test(f.designator || ''), mesaj: 'ICAO type code: 2 to 4 letters or digits.' },
  ...tipVeriAlanlari(f),
];

/** Formun eksiği — veritabanının reddedeceğini ÖNCEDEN söyler; yoksa null. */
export function tipFormHatasi(f) {
  return ilkEksik(tipAlanlari(f));
}

// ── GERİ ÇEKİLMİŞ TİP (WITHDRAWN, adım T1/T2) ─────────────────────────────────
// Bir kod, geri çekilmemiş EN AZ BİR satırı varsa geçerlidir — veritabanı kapısı `tip_listede_mi` (20260930j) ile
// AYNI kural. Geri çekilmiş satır aramada çıkmaz, yeni uçağa/yetkiye seçilemez; ona bağlı olanlar etkilenmez.
export const secilebilirTipler = tipler => (tipler || []).filter(t => !t.withdrawn_at);
export const tipKoduGecerli = (tipler, kod) => secilebilirTipler(tipler).some(t => t.designator === kod);

/** "2J" → { motorSayi:'2', motorTur:'J' }; biçim dışıysa boş (formda "seçilmemiş" görünür, uydurulmaz). */
export function motorParcala(engine) {
  const m = /^(\d{1,2})([A-Z])$/.exec(String(engine || ''));
  return m ? { motorSayi: m[1], motorTur: m[2] } : { motorSayi: '', motorTur: '' };
}
